const getCurrentSchoolYear = () => {
  const newSchoolYearDate = new Date();
  newSchoolYearDate.setMonth(3);

  const today = new Date();
  if (today.getMonth() < newSchoolYearDate.getMonth()) {
    return today.getFullYear() - 1;
  } else {
    return today.getFullYear();
  }
};

export { getCurrentSchoolYear };
